/**
 * BudgetTypeService
 * Service for BudgetType lookup CRUD operations
 */
import { CrudService } from '../base/CrudService';
/** Service for BudgetType CRUD operations */
export class BudgetTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetTypeService.DEFAULT_SERVICE_PATH,
            basePath: BudgetTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetTypeService.DEFAULT_SERVICE_PATH = 'budgets';
BudgetTypeService.BASE_PATH = 'api/budgettypes';
//# sourceMappingURL=BudgetTypeService.js.map